module.exports = __webpack_public_path__ + "static/jabra-54280a6dd7a502952afb1a7f380e54a7.svg";